import React from "react";
import WebSkillFilter from "./WebSkillFilter";
import WebPlayerStatusFilter from "./WebPlayerStatusFilter";
import WebCountryFilter from "./WebCountryFilter";
import WebPlayerSearch from "./WebPlayerSearch";
import WebPriceFilter from "./WebPriceFilter";
import WebSortByFilter from "./WebSortByFilter";
import { Fragment } from "react";
import config from "../../../common/config";
import { getTrans } from "../../../common";
import { TransContext } from "../../../Context";
import { Consume } from "../../../Context/Consumer";

const WebPlayerListFilters = (props) => {
  const { PlayerListData } = props;
  const isMobileFiltersVisible = PlayerListData?.isMobileFiltersVisible;

  const openFilterPopUp = () => {
    PlayerListData.setMobileFiltersFlag();
  };

  const renderMoreFilter = () => {
    return (
      <Fragment>
        <div className="si-plyrSel__form">
          <div className="si-plyrSel__form-list">
            <WebSortByFilter />
          </div>
          <div className="si-plyrSel__form-list">
            <WebPriceFilter />
          </div>
        </div>
        <div className="si-plyrSel__form">
          {/* <div className="si-plyrSel__form-list"><WebPriceFilter /></div> */}
          <WebPlayerSearch />
        </div>
        {/* 
        <div
          className="si-plyrSel__filter"
          onClick={(e) => {
            openFilterPopUp();
          }}
        >
          <span>Less Filters</span>
        </div> */}
      </Fragment>
    );
  };

  const renderMoreFilterMobile = () => {
    const transData = props.TransData.data;
    if (isMobileFiltersVisible) {
      return (
        <Fragment>
          <div className="si-plyrSel__form">
            <div className="si-plyrSel__form-list">
              <WebSortByFilter />
            </div>
            <div className="si-plyrSel__form-list">
              <WebPriceFilter />
            </div>
          </div>
          <div className="si-plyrSel__form">
            {/* <div className="si-plyrSel__form-list"><WebPriceFilter /></div> */}
            <WebPlayerSearch />
          </div>

          <div
            className="si-plyrSel__filter si-active"
            onClick={(e) => {
              openFilterPopUp();
            }}
          >
            <span>{getTrans(transData, "less_filter", "Less Filter")}</span>
          </div>
        </Fragment>
      );
    } else {
      return (
        <div
          className="si-plyrSel__filter"
          onClick={(e) => {
            openFilterPopUp();
          }}
        >
          <span>{getTrans(transData, "more_filter", "More Filters")}</span>
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <div className="si-plyrSel__form">
        <div className="si-plyrSel__form-list">
          <WebSkillFilter />
        </div>
        <div className="si-plyrSel__form-list">
          <WebCountryFilter />
        </div>
      </div>
      {config.isMobile ? renderMoreFilterMobile() : renderMoreFilter()}
    </React.Fragment>
  );
};

export default Consume(WebPlayerListFilters, [TransContext]);
